export const FAQ_GROUPS = [
  {
    group: "Quotations and Booking",
    items: [
      {
        q: "How do I get a quotation?",
        a: "Send your property details and photos through WhatsApp. Our team will recommend the most suitable service and provide a prompt quotation.",
      },
      {
        q: "Do you provide free onsite quotations?",
        a: "For most residential and small commercial jobs, a WhatsApp photo quote is sufficient. Larger commercial contracts can be scheduled for a site visit.",
      },
    ],
  },
  {
    group: "Equipment and Supplies",
    items: [
      {
        q: "Do you bring your own equipment?",
        a: "Yes. Our team arrives with professional-grade cleaning equipment, supplies and PPE.",
      },
    ],
  },
  {
    group: "Insurance & Coverage",
    items: [
      {
        q: "Are your cleaners insured?",
        a: "Emilio's Solutions is covered by Public Liability Insurance for added peace of mind.",
      },
      {
        q: "Which areas do you serve?",
        a: "Cleaning services are available throughout Singapore, including HDB, condominiums, landed homes and commercial premises.",
      },
    ],
  },
  {
    group: "Scheduling",
    items: [
      {
        q: "How long does the cleaning take?",
        a: "It depends on the property size, condition and selected services. Most residential post-renovation jobs run 4–8 hours.",
      },
      {
        q: "Do you clean on weekends?",
        a: "Yes, subject to availability. Please share your preferred slot when enquiring.",
      },
    ],
  },
  {
    group: "Results & Limitations",
    items: [
      {
        q: "Will you remove every stain?",
        a: "We treat visible stains professionally and remove most, though deeply set or etched marks may not be fully removable.",
      },
    ],
  },
];

// Homepage 5-question preview:
export const FAQ_PREVIEW = [
  FAQ_GROUPS[0].items[0],
  FAQ_GROUPS[1].items[0],
  FAQ_GROUPS[2].items[0],
  FAQ_GROUPS[3].items[0],
  FAQ_GROUPS[2].items[1],
];
